import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { filter } from 'rxjs/operators';
import { UsuarioDataNascimentoService } from './service/usuario-data-nascimento/usuario-data-nascimento.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  @ViewChild('dataNascimentoTemplate', { static: true }) dataNascimentoTemplate: TemplateRef<any>;

  modalDataNascimentoRef: BsModalRef;
  dataNascimento = '';
  dataNascimentoErro = '';
  dataNascimentoMaxima = new Date().toISOString().slice(0, 10);
  salvandoDataNascimento = false;

  constructor(
    private router: Router,
    private modalService: BsModalService,
    private usuarioDataNascimentoService: UsuarioDataNascimentoService) {}

  ngOnInit() {
    this.verificarDataNascimentoPendente();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => this.verificarDataNascimentoPendente());
  }

  salvarDataNascimento() {
    this.dataNascimentoErro = '';

    if (!this.usuarioDataNascimentoService.dataNascimentoValida(this.dataNascimento)) {
      this.dataNascimentoErro = 'Informe uma data de nascimento válida.';
      return;
    }

    this.salvandoDataNascimento = true;

    this.usuarioDataNascimentoService.atualizarDataNascimentoUsuarioLogado(this.dataNascimento).subscribe(() => {
      this.salvandoDataNascimento = false;
      this.fecharModalDataNascimento();
    }, erro => {
      this.salvandoDataNascimento = false;
      this.dataNascimentoErro = this.extrairMensagemErro(erro);
    });
  }

  private verificarDataNascimentoPendente() {
    if (this.modalDataNascimentoRef || this.salvandoDataNascimento) {
      return;
    }

    if (this.usuarioDataNascimentoService.usuarioLogadoPrecisaDataNascimento()) {
      this.dataNascimento = '';
      this.dataNascimentoErro = '';

      setTimeout(() => {
        if (!this.modalDataNascimentoRef && this.usuarioDataNascimentoService.usuarioLogadoPrecisaDataNascimento()) {
          this.modalDataNascimentoRef = this.modalService.show(this.dataNascimentoTemplate, {
            class: 'modal-sm',
            backdrop: 'static',
            keyboard: false
          });
        }
      });
    }
  }

  private fecharModalDataNascimento() {
    if (this.modalDataNascimentoRef) {
      this.modalDataNascimentoRef.hide();
      this.modalDataNascimentoRef = null;
    }
  }

  private extrairMensagemErro(erro: any): string {
    if (erro && erro.error && erro.error.message) {
      return erro.error.message;
    }

    if (erro && erro.message) {
      return erro.message;
    }

    return 'Não foi possível salvar a data de nascimento.';
  }

}
